export var AccountStateEnum;
(function (AccountStateEnum) {
    AccountStateEnum["CHECKED"] = "CHECKED";
    AccountStateEnum["PENDING"] = "PENDING";
    AccountStateEnum["WARNING"] = "WARNING";
    AccountStateEnum["ERROR"] = "ERROR";
    AccountStateEnum["UNDEFINED"] = "UNDEFINED";
})(AccountStateEnum || (AccountStateEnum = {}));
export var DocumentStatusEnum;
(function (DocumentStatusEnum) {
    DocumentStatusEnum["SENT"] = "SENT";
    DocumentStatusEnum["VALID"] = "VALID";
    DocumentStatusEnum["PENDING"] = "PENDING";
    DocumentStatusEnum["INVALID"] = "INVALID";
    DocumentStatusEnum["EXPIRED"] = "EXPIRED";
    DocumentStatusEnum["EXPIRES_SOON"] = "EXPIRES_SOON";
})(DocumentStatusEnum || (DocumentStatusEnum = {}));
